module.exports = __webpack_public_path__ + "static/media/1_priority_icon.7666b487.svg";